export var NoGroupHeaderId;
(function (NoGroupHeaderId) {
    NoGroupHeaderId[NoGroupHeaderId["None"] = 0] = "None";
})(NoGroupHeaderId || (NoGroupHeaderId = {}));
export var TimeHeaderId;
(function (TimeHeaderId) {
    TimeHeaderId[TimeHeaderId["Pinned"] = 1] = "Pinned";
    TimeHeaderId[TimeHeaderId["Today"] = 2] = "Today";
    TimeHeaderId[TimeHeaderId["Yesterday"] = 3] = "Yesterday";
    TimeHeaderId[TimeHeaderId["ThisWeek"] = 4] = "ThisWeek";
    TimeHeaderId[TimeHeaderId["LastWeek"] = 5] = "LastWeek";
    TimeHeaderId[TimeHeaderId["ThisMonth"] = 6] = "ThisMonth";
    TimeHeaderId[TimeHeaderId["LastMonth"] = 7] = "LastMonth";
    TimeHeaderId[TimeHeaderId["Older"] = 8] = "Older";
    TimeHeaderId[TimeHeaderId["OneMonthOlder"] = 9] = "OneMonthOlder";
    TimeHeaderId[TimeHeaderId["TwoMonthsOlder"] = 10] = "TwoMonthsOlder";
})(TimeHeaderId || (TimeHeaderId = {}));
export var SizeHeaderId;
(function (SizeHeaderId) {
    SizeHeaderId[SizeHeaderId["Tiny"] = 11] = "Tiny";
    SizeHeaderId[SizeHeaderId["Small"] = 12] = "Small";
    SizeHeaderId[SizeHeaderId["Medium"] = 13] = "Medium";
    SizeHeaderId[SizeHeaderId["Large"] = 14] = "Large";
    SizeHeaderId[SizeHeaderId["VeryLarge"] = 15] = "VeryLarge";
    SizeHeaderId[SizeHeaderId["Huge"] = 16] = "Huge";
    SizeHeaderId[SizeHeaderId["Enormous"] = 17] = "Enormous";
})(SizeHeaderId || (SizeHeaderId = {}));
export var SenderGroupHeaderId;
(function (SenderGroupHeaderId) {
    SenderGroupHeaderId[SenderGroupHeaderId["Unknown"] = 18] = "Unknown";
})(SenderGroupHeaderId || (SenderGroupHeaderId = {}));
//# sourceMappingURL=GroupHeaderId.js.map